// extracted by mini-css-extract-plugin
module.exports = {"oauth-btn":"OAuthButton_oauth-btn__38nkD"};